import { IConfiguration, IPushbackConfiguration } from "../models/configuration/pushback/IConfiguration";
import { deepEqual } from "./deepEqual";

const stripEncompassInstanceId = (config: IConfiguration | null): IConfiguration | null => {
    if (!config) return null;
    const sanitized = { ...(config as IConfiguration & { EncompassInstanceId?: unknown }) };
    delete sanitized.EncompassInstanceId;
    return sanitized;
};

const normalizePushbackConfig = (
    config?: IPushbackConfiguration | IConfiguration | null
): IConfiguration | null => {
    if (!config) return null;
    if ((config as IPushbackConfiguration).Configuration) {
        return stripEncompassInstanceId((config as IPushbackConfiguration).Configuration);
    }
    return stripEncompassInstanceId(config as IConfiguration);
};

export const hasPushbackConfigChanges = (
    current: IPushbackConfiguration,
    persisted?: IPushbackConfiguration | null
): boolean => {
    if (!persisted) return true;
    return !deepEqual(normalizePushbackConfig(current), normalizePushbackConfig(persisted));
};
